<template>
  <div class="bleed">
    <div class="conteneur">
      <img src="../assets/menu.svg" alt="" class="header" />
      <nav class="menu">
        <router-link :to="{ name: 'Portfolio' }">Portfolio</router-link> |
        <router-link :to="{ name: 'Connaissances' }">Connaissances</router-link>
        |
        <router-link :to="{ name: 'Contact' }">Contact</router-link>
      </nav>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
